import React from 'react';
import { defineMessages, useIntl } from 'react-intl-next';

import { ConfluenceIcon, ConfluenceLogo } from '@atlaskit/logo';
import { AtlassianNavigation, ProductHome } from '@atlaskit/atlassian-navigation';

import { ErrorPageComponent } from '@confluence/not-found';

import notFoundImage from './not-found-v2.svg';

const i18n = defineMessages({
	title: {
		id: 'external-share.not-found.title',
		defaultMessage: 'We can’t find the public link',
		description: 'Title of error page displayed when a public page cannot be found',
	},
	message: {
		id: 'external-share.not-found.description',
		defaultMessage:
			'We looked everywhere, but this public link either doesn’t exist or isn’t public anymore.',
		description:
			'Description of why the user is seeing this error page when trying to visit a public page',
	},
});

export const ExternalPageNotFoundV2 = () => {
	const intl = useIntl();
	const ConfluenceHome = () => (
		<ProductHome
			href="https://www.atlassian.com/software/confluence"
			icon={ConfluenceIcon}
			logo={ConfluenceLogo}
		/>
	);
	return (
		<>
			<AtlassianNavigation
				label="Navigation bar for public page not found error page"
				primaryItems={[]}
				renderProductHome={ConfluenceHome}
			/>
			<ErrorPageComponent
				errorImage={notFoundImage}
				errorTitle={intl.formatMessage(i18n.title)}
				errorMessage={intl.formatMessage(i18n.message)}
			/>
		</>
	);
};
